import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { siteConfig } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10">
      {/* CTA Section */}
      <div className="bg-gradient-to-r from-orange-500/10 via-green-400/10 to-orange-500/10 border-b border-white/10">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4">
              Pronto a Trasformarti?
            </h2>
            <p className="text-lg md:text-xl text-gray-300 mb-8">
              La tua prima sessione è gratuita. Nessun impegno. Solo risultati.
            </p>
            <Link to="/contatti">
              <Button className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-8 py-7 text-base uppercase tracking-wide shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transition-all duration-300 hover:scale-105">
                Prenota Ora la Prova Gratuita
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img 
              src="/logo-performove-white.png" 
              alt="Performove Training Lab" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Non siamo una palestra tradizionale. Siamo un centro altamente specializzato di personal training.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4 text-sm">
              Link Rapidi
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/chi-siamo" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/servizi" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Servizi
                </Link>
              </li>
              <li>
                <Link to="/risultati" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Risultati
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Contatti
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4 text-sm">
              Contatti
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="text-orange-500 w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href={`tel:${siteConfig.contact.phone}`} className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  {siteConfig.contact.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="text-orange-500 w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${siteConfig.contact.email}`} className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  {siteConfig.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-500 w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  {siteConfig.contact.address}
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-4 text-sm">
              Seguici
            </h4>
            <div className="flex space-x-4">
              <a
                href={siteConfig.contact.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-gradient-to-r hover:from-orange-500 hover:to-green-400 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href={siteConfig.contact.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-gradient-to-r hover:from-orange-500 hover:to-green-400 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Performove Training_LAB. Tutti i diritti riservati.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-orange-500 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/ringraziamenti" className="text-gray-500 hover:text-orange-500 text-sm transition-colors">
                Ringraziamenti
              </Link>
              <a href="#" className="text-gray-500 hover:text-orange-500 text-sm transition-colors">
                Termini e Condizioni
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
